<template>
  <p>Nothing to see here</p>
</template>
